/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CommunicationAttachmentDto, EDocDto, EDocSignerRole } from '@gh/builder-shared-data';
import { FileListItem } from '@gh/common-internal-shared';
import { get } from 'lodash';

export type EDoc = EDocDto;
export type EDocLink = CommunicationAttachmentDto;
export type EDocDetails = {
  owner1: string;
  owner2: string;
  owner3: string;
  email1: string;
  email2: string;
  email3: string;
  files: FileListItem[];
};

export const getEDocSignerByRole = (document: EDoc, role: EDocSignerRole) =>
  document.signers.find((signer) => signer.type === role);

export const getEDocSignerNameByRole = (document: EDoc, role: EDocSignerRole) =>
  get(getEDocSignerByRole(document, role), 'name', '');

export const getEDocSignerEmailByRole = (document: EDoc, role: EDocSignerRole) =>
  get(getEDocSignerByRole(document, role), 'email', '');

export const getEDocSignerStatusByRole = (document: EDoc, role: EDocSignerRole) =>
  get(getEDocSignerByRole(document, role), 'status');
